import gql from "graphql-tag";

export const PINCODE = gql`
  query pincode($pincode: String!) {
    pincode(pincode: $pincode) {
      id
      isCod
      isPrepaid
      isShippable
      pincode
      countryArea
      city
    }
  }
`;
